import { z } from 'zod';

export const issuedCouponInfoSchema = z.object({
  couponCode: z.string(),
  couponName: z.string(),
  description: z.string().nullable().optional(),
  productId: z.number().nullable().optional(), // 적용 상품 ID (플랜/코인, null이면 모든 상품)
  productSeq: z.number().nullable().optional(), // 상품 정렬 seq
});

export const issuedPointInfoSchema = z.object({
  amount: z.number(),
  validDays: z.number().nullable().optional(),
});

export const referralBenefitResultSchema = z.object({
  success: z.boolean(),
  benefitType: z.enum(['COUPON', 'POINT']).nullable().optional(),
  failReasonCode: z.number().nullable().optional(),
  issuedCoupons: z.array(issuedCouponInfoSchema).nullable().optional(),
  issuedPoint: issuedPointInfoSchema.nullable().optional(),
});

export type ReferralBenefitResultType = z.infer<
  typeof referralBenefitResultSchema
>;
export type IssuedCouponInfoType = z.infer<typeof issuedCouponInfoSchema>;
export type IssuedPointInfoType = z.infer<typeof issuedPointInfoSchema>;
